import type { RestaurantPresetConfigurationRequest } from "@/app/generated/api/schemas";

// Keep the legacy table fields for the backward-compatible preset contract, but
// leave the branch layout empty so the dedicated POS starter owns its setup.
export const restaurantPresetCompatibilityConfiguration = Object.freeze({
  sectionName: "Restaurant",
  sectionCode: "MAIN",
  tableNamePrefix: "Table",
  tableCount: 1,
  defaultSeatsPerTable: 4,
  createFloorPlan: false,
  createBookingResources: false,
  createAccessGroups: false,
  createPosLayout: false,
}) satisfies RestaurantPresetConfigurationRequest;

export function isRestaurantConfiguration(
  value: unknown,
): value is RestaurantPresetConfigurationRequest {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  const configuration = value as Record<string, unknown>;

  return typeof configuration.sectionName === "string"
    && typeof configuration.sectionCode === "string"
    && typeof configuration.tableNamePrefix === "string"
    && typeof configuration.tableCount === "number"
    && typeof configuration.defaultSeatsPerTable === "number"
    && typeof configuration.createFloorPlan === "boolean"
    && typeof configuration.createBookingResources === "boolean"
    && typeof configuration.createAccessGroups === "boolean"
    && (
      configuration.createPosLayout === undefined
      || typeof configuration.createPosLayout === "boolean"
    );
}

export function initialPresetRecommendedAppCodes(
  recommendedAppCodes: readonly string[],
  savedAppCodes?: readonly string[],
): string[] {
  if (savedAppCodes === undefined) {
    return [...recommendedAppCodes];
  }

  return recommendedAppCodes.filter((appCode) => savedAppCodes.includes(appCode));
}
